import PropTypes from 'prop-types';
import React from 'react';
import { external_links } from '../../utils/external_links';

const TextSection = ({ content }) => {
  const html = external_links(content);
  return (<div className="section-text" dangerouslySetInnerHTML={{ __html: html }} />);
};

TextSection.propTypes = {
  content: PropTypes.string.isRequired
};

export default TextSection;
